// extracted by mini-css-extract-plugin
export var hamburgerRoot = "styles-module--hamburgerRoot--3g0GE";
export var hamburgerBox = "styles-module--hamburgerBox--2cNOG";
export var hamburgerInner = "styles-module--hamburgerInner--28bxD";
export var hamburgerSpin = "styles-module--hamburgerSpin--3IZSI";